module.exports = __webpack_public_path__ + "img/Speaker=Aarthi Scott.aa134a34.png";